import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=b33140a2&"
import script from "./MobileMenu.vue?vue&type=script&lang=js&"
export * from "./MobileMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiBaseMenu: require('/app/components/ui/base/Menu.vue').default,UiSharedLang: require('/app/components/ui/shared/lang.vue').default})
